import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../pages/main/content/CommonTranslationKey";
import Button from "@mui/material/Button";
import React from "react";


interface ChangePasswordButtonProps {
    onClick: (event?: any) => void;
}

export function ChangePasswordButton({onClick}: ChangePasswordButtonProps) {
    return (
        <Button
            color={"primary"}
            variant={"contained"}
            autoFocus={true}
            onClick={onClick}
        >
            {_transl(CommonTranslationKey.CHANGE_PASSWORD)}
        </Button>
    )
}


